import { Candidate, Job } from 'types/types';
import { JobAnalysisScore } from 'components/JobMatchAnalysis';

interface AnalysisState {
  job: Job | null;
  candidate: Candidate | null;
  analysis: JobAnalysisScore | null;
  resume: string | null;
  savedResumeId: string | null;
}

const initialState: AnalysisState = {
  job: null,
  candidate: null,
  analysis: null,
  resume: null,
  savedResumeId: null,
};

export type { AnalysisState };
export { initialState };
